import { createFileRoute } from "@tanstack/react-router";
import Results from "@/pages/site/Results";

export const Route = createFileRoute("/results")({
  component: () => <Results />,
});
